import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { CtaBand } from "@/components/common/CtaBand";
import { BeforeAfterGallery } from "@/components/common/BeforeAfterGallery";
import { MapSection } from "@/components/home/MapSection";
import { Seo } from "@/components/common/Seo";
import { buildBreadcrumbSchema } from "@/lib/schema";
import { LOCATIONS } from "@/data/site";

export default function Locations() {
  return (
    <div data-testid="locations-page">
      <Seo
        title="Dentist Near You in Varanasi | Dr. Ankesh Seth Locations"
        description="Find a trusted dentist near you in Varanasi. Dr. Ankesh Seth's Paharia clinic serves patients across Pandeypur, Sarnath, Ashapur, Bhojuveer and Orderly Bazar."
        path="/locations"
        jsonLd={buildBreadcrumbSchema([{ name: "Home", path: "/" }, { name: "Locations", path: "/locations" }])}
      />
      <PageHero
        eyebrow="Locations"
        titleLines={["Serving Patients", "Across Varanasi"]}
        subtitle="Conveniently located in Paharia, we welcome patients from neighbourhoods all across the city. Find directions and local information for your area."
        crumbs={[{ label: "Locations" }]}
      />

      <section className="bg-white">
        <div className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32 lg:px-20">
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {LOCATIONS.map((l, i) => (
              <Reveal key={l.slug} delay={(i % 3) * 0.07}>
                <Link
                  to={`/${l.slug}`}
                  data-testid={`location-item-${l.slug}`}
                  className="group flex h-full flex-col justify-between rounded-2xl border border-brand-line bg-brand-soft p-8 transition-all duration-300 hover:-translate-y-1 hover:bg-brand-blue"
                >
                  <div>
                    <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-white text-brand-blue">
                      <MapPin className="h-6 w-6" />
                    </span>
                    <span className="mt-5 block text-xs font-semibold uppercase tracking-wider text-brand-green">
                      {l.distance}
                    </span>
                    <h3 className="mt-1 font-display text-2xl font-medium text-brand-dark transition-colors group-hover:text-white">
                      Dentist in {l.area}
                    </h3>
                    <p className="mt-2 text-sm text-brand-muted transition-colors group-hover:text-white/80">
                      {l.short}
                    </p>
                  </div>
                  <span className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-brand-blue transition-colors group-hover:text-white">
                    View location
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <BeforeAfterGallery muted />
      <CtaBand />
      <MapSection />
    </div>
  );
}
